/**
* Task card controller
* @author Ryan Gladstone
*/

function TaskCardController(
  $scope,
  $log,
  $translate,
  taskModalService,
  confirmationDialog,
  LoggedInUser,
  toastWrapperService,
  layoutService,
  analyticsService
) {
  function updateTaskSuccess(updatedTask) {
    if (updatedTask) {
      $scope.task = updatedTask;

      toastWrapperService.createToast($translate.instant('TASK_UPDATED'), 'success');
      analyticsService.trackEvent('Task management (task card)', 'Updated task');
    }
  }

  function deleteConfirmedAction() {
    const taskId = $scope.task.id;

    $scope.task.delete().then((response) => {
      $log.log('task deleted successfully: ', response);

      $scope.task = null;

      toastWrapperService.createToast($translate.instant('TASK_DELETED'), 'success');
      analyticsService.trackEvent('Task management (tasks feed)', 'Deleted task');

      $scope.removeTaskFromResults({ id: taskId });
    }, (response) => {
      $log.error('task deletion error: ', response);
    });
  }

  function copyWithExisitingStory(oldStory, newTask) {
    const completeTask = newTask;
    completeTask.story = angular.copy(oldStory);
    return completeTask;
  }

  $scope.eventLimit = -1;
  $scope.eventLimitSlim = 1;

  $scope.toggleEventLimit = () => {
    $scope.eventLimit = $scope.eventLimit === -1 ? ($scope.task.events.length - 1) * -1 : -1;
  };

  $scope.toggleEventLimitSlim = () => {
    $scope.eventLimitSlim = $scope.eventLimitSlim === 1 ? $scope.task.events.length : 1;
  };

  $scope.layout = layoutService;

  $scope.currentUser = angular.copy(LoggedInUser);
  $scope.user = angular.copy(LoggedInUser);

  $scope.updateTaskInModal = () => {
    taskModalService.saveTask(updateTaskSuccess, $scope.task);
  };

  $scope.deleteTask = () => {
    confirmationDialog.confirm('DELETE_TASK_Q', deleteConfirmedAction);
  };

  $scope.$on('task-deleted', (event, args) => {
    // do what you want to do
    if ($scope.task.id === args.id) {
      $scope.task.deleted = 'yup';
    }
  });

  $scope.$on('task-updated', (event, args) => {
    // do what you want to do
    if ($scope.task.id === args.task.id) {
      $scope.task = copyWithExisitingStory($scope.task.story, args.task);
    }
  });
}

const TaskCardControllerArray = [
  '$scope',
  '$log',
  '$translate',
  'taskModalService',
  'confirmationDialog',
  'LoggedInUser',
  'toastWrapperService',
  'layoutService',
  'analyticsService',
  TaskCardController
];

export default function (ngModule) {
  ngModule.controller('TaskCardController', TaskCardControllerArray);
}
